/* v8 ignore start */
import RollbarLibrary from "rollbar";

import {AppConfiguration} from "@/appConfiguration";
import {Rollbar} from "@/lib/utils/rollbar";

const ROLLBAR_CLIENT_TOKEN = "cb2ae67bb10d479099d8ba68dbe3d85b";
const rollbarClient = new RollbarLibrary({
  accessToken: ROLLBAR_CLIENT_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: AppConfiguration.environment,
  enabled: !["development", "test"].includes(AppConfiguration.environment),
  payload: {
    environment: AppConfiguration.environment,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: AppConfiguration.codeVersion,
        guess_uncaught_frames: true,
      },
    },
  },
});
export const RollbarClient = new Rollbar(rollbarClient);
/* v8 ignore stop */
